import axiosClient from "../axios/axiosClient";

export function getAcademicPrograms() {
  return axiosClient.get("/academic-programs");
}

export function getAcademicProgram(academicProgramId) {
  return axiosClient.get(`/academic-programs/${academicProgramId}`);
}

export function createAcademicProgram(data) {
  return axiosClient.post("/academic-programs", data);
}

export const updateAcademicProgram = (academicProgramId, data) => {
  return axiosClient.put(`/academic-programs/${academicProgramId}`, data);
};

export function deleteAcademicProgram(academicProgramId) {
  return axiosClient.delete(`/academic-programs/${academicProgramId}`);
}
